import React from 'react';

interface IProps {
  currentLength: number;
  maxLength: number;
  className?: string;
}

const CharCounter = ({ currentLength, maxLength, className }:IProps) => (
  <div id='transactionDetailsCharCount' className={className}>
    {currentLength}
    /
    {maxLength}
  </div>
);

export default CharCounter;
